__webpack_require__.p = "/ui/insu/resources/auto-claim/dist/";